import { BaSeTheme } from '@base/react';
import styled from 'styled-components';

export const Description = styled.p`
  color: #000;
  font-size: 1em;
  font-style: normal;
  font-weight: 400;
  line-height: 1.5em;

  strong {
    font-weight: bold;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  gap: 1em;
  p,
  strong,
  h1 {
    font-family: 'Inter', sans-serif;
  }
`;

export const Title = styled.div`
  border: 1px solid ${BaSeTheme.colors.institucionais.cinzaSebrae90};
  background-color: #fff;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1em 0;
  h1 {
    color: #617385;
    font-size: 1.6em;
    font-weight: bold;
  }
`;

export const Content = styled.div`
  background-color: #fff;
  max-height: 310px;
  overflow: auto;
  padding: 1em;
  @media (max-width: 425px) {
    max-height: 500px;
    padding: 0.75em;
  }

  @media (min-width: 426px) and (max-width: 768px) {
    max-height: 600px;
  }

  @media (min-width: 769px) and (max-width: 1024px) {
    max-height: 310px;

  }

  @media (min-width: 1025px) and (max-width: 1440px) {
    max-height: 370px;
  }

  @media (min-width: 1441px) {
    max-height: 370px;

  }
`;

export const Footer = styled.div`
  background-color: #fff;
  box-shadow: 0px -4px 8px rgba(20, 46, 82, 0.2);
  padding: 0.5em 1em;

  @media (max-width: 375px) {
    max-height: 100px;
  }
`;







/////////
// export const Container = styled.div`
//   padding-bottom: 1em;
//   display: grid;
//   gap: 1em;
//   p,
//   strong,
//   h1,
//   label {
//     font-family: 'Inter', sans-serif;
//   }
// `;
